import React, {useEffect, useState} from 'react';
import {useInternationalization} from '@progress/kendo-react-intl';

import {GridFooterCellProps} from "./gridFooterCellProps";

import './gridFooterCell.scss';

const GridFooterCell: React.FC<GridFooterCellProps> = ({
                                                           gridData,
                                                           scale,
                                                           isPercent,
                                                           field,
                                                           includeTotalCount,
                                                           tdProps,
                                                           style,
                                                           className
                                                       }) => {

  const [totalSum, setTotalSum] = useState<number>(0);
  const intl = useInternationalization();

  useEffect(() => {
    let sum = 0;
    let final;
    gridData?.map((row) => {
      let dataItem: any = field && row[field];

      if (dataItem) {
        sum += 1 * dataItem;
        final = intl.toString(sum, (isPercent ? 'p' : 'n') + scale);
      }
    });

    setTotalSum(final);
  }, []);

  if (!gridData) {
    return <td {...tdProps} style={style} className={className}/>;
  }

  return (
    <td {...tdProps} style={style} className={`grid-footer-cell ${className}`}>
      {includeTotalCount ? <div>{totalSum}</div> : null}
    </td>
  );

  // const [totalSum, setTotalSum] = useState<number>(0);
  // const fieldForObject = field?.lastIndexOf('_') !== -1 ? field?.substring(0, field?.lastIndexOf('_')) : field;
  //
  // const intl = useInternationalization();
  //
  //   useEffect(() => {
  //       let sum: any = 0;
  //       let final: any = 0;
  //       gridData?.map((row) => {
  //         let dataItem: any = fieldForObject && row[fieldForObject];
  //         // @ts-ignore
  //         let tempValue: any = dataItem?.rowAmount ? intl.toString(dataItem.rowAmount) : '0';
  //
  //         sum += 1 * tempValue;
  //
  //         // final = intl.toString(sum, (dataItem.isPercent ? 'p' : 'n') + scale);
  //         final = intl.toString(sum, (isPercent ? 'p' : 'n') + scale);
  //       });
  //     setTotalSum(final)
  //   }, []);
  //
  //   if (!gridData) {
  //       return <td {...tdProps} style={style} className={className}/>
  //   }
  //
  // return (
  //   <td {...tdProps} style={style} className={`grid-footer-cell ${className}`}>
  //     {includeTotalCount ? <div>{totalSum}</div> : null}
  //   </td>
  // );


};

export default GridFooterCell;
